// import { Box, VStack, Tooltip, Menu, MenuButton } from "@chakra-ui/react";
// import "./LeftSideNav.scss";
// import { useSectorsContext } from "../../customHooks/useSectorsContext";
// import { useSelector } from "react-redux";
// import { useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";

// // Icons
// import FoodKindredProductsIcon from "../../components/Icons/FoodKindredProductsIcon";
// import FabricatedMetalProductsIcon from "../../components/Icons/FabricatedMetalProductsIcon";
// import IndustrialCommercialMachineryComputerEquipmentIcon from "../../components/Icons/IndustrialCommercialMachineryComputerEquipmentIcon";
// import TextileMillProductIcon from "../../components/Icons/TextileMillProductIcon";
// import ApparelFinishedProductsIcon from "../../components/Icons/ApparelFinishedProductsIcon";
// import PrimaryMetalsIndustryIcon from "../../components/Icons/PrimaryMetalsIndustryIcon";
// import RubberMiscellaneousPlasticProductsIcon from "../../components/Icons/RubberMiscellaneousPlasticProductsIcon";
// import ElectronicEquipmentComponentsIcon from "../../components/Icons/ElectronicEquipmentComponentsIcon";

// const LeftSideNav = () => {
//   const navigation = useNavigate();
//   const { sectorId } = useParams();
//   const { sectorPopularData } = useSectorsContext();
//   const [currentIndustryId, setCurrentIndustryId] = useState(sectorId);
//   const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

//   const handleSectorClickRedirect = (sectorId) => {
//     setCurrentIndustryId(sectorId);
//     navigation(`/sector/${sectorId}/details`);
//   };

//   // Hidden sector IDs
//   const hiddenSectorIds = [
//     "67c59f894605e819d8fb86ce", // TransportationEquipmentIcon
//     "67c59f894605e819d8fb86c4", // FabricatedMetalProductsIcon
//     "67c59f894605e819d8fb86bc", // IndustrialCommercialMachineryComputerEquipmentIcon
//     "67c59f894605e819d8fb86cd", // RubberMiscellaneousPlasticProductsIcon
//     "67c59f894605e819d8fb86c5", // ElectronicEquipmentComponentsIcon
//   ];

//   const getSectorIcon = (sectorId) => {
//     switch (sectorId) {
//       case "67c59f894605e819d8fb86ca":
//         return FoodKindredProductsIcon;
//       case "67c59f894605e819d8fb86c4":
//         return FabricatedMetalProductsIcon;
//       case "67c59f894605e819d8fb86af":
//         return TextileMillProductIcon;
//       case "67c59f894605e819d8fb86bc":
//         return IndustrialCommercialMachineryComputerEquipmentIcon;
//       case "67c59f894605e819d8fb86c0":
//         return ApparelFinishedProductsIcon;
//       case "67c59f894605e819d8fb86c3":
//         return PrimaryMetalsIndustryIcon;
//       case "67c59f894605e819d8fb86cd":
//         return RubberMiscellaneousPlasticProductsIcon;
//       case "67c59f894605e819d8fb86c5":
//         return ElectronicEquipmentComponentsIcon;
//       default:
//         return null;
//     }
//   };

//   return (
//     <VStack className="left-side-nav">
//       <VStack align="start" fontSize="14px">
//         {sectorPopularData &&
//           sectorPopularData.map((sector) => {
//             if (hiddenSectorIds.includes(sector._id)) return null;

//             const IconComponent = getSectorIcon(sector._id);
//             if (!IconComponent) return null;

//             return (
//               <Box
//                 className="industry-block-icon"
//                 bgColor={sector._id === currentIndustryId ? "#B1B1B1" : "#FFFFFF"}
//                 key={`sector-${sector._id}`}
//               >
//                 <Menu>
//                   <Tooltip label={sector.sectorName} fontSize="11px">
//                     <MenuButton
//                       // onClick={() => {
//                       //   if (!isAuthenticatedUser) {
//                       //     handleSectorClickRedirect(sector._id);
//                       //   }
//                       // }}
//                       onClick={() => handleSectorClickRedirect(sector._id)}
//                     >
//                       <IconComponent
//                         color={sector._id === currentIndustryId ? "#FFFFFF" : "#5D5D5D"}
//                       />
//                     </MenuButton>
//                   </Tooltip>
//                 </Menu>
//               </Box>
//             );
//           })}
//       </VStack>
//     </VStack>
//   );
// };

// export default LeftSideNav;



import { Box, VStack, Tooltip, Menu, MenuButton } from "@chakra-ui/react";
import "./LeftSideNav.scss";
import { useSectorsContext } from "../../customHooks/useSectorsContext";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react"; // <-- added useEffect
import { useNavigate, useParams } from "react-router-dom";

// Icons
import FoodKindredProductsIcon from "../../components/Icons/FoodKindredProductsIcon";
import FabricatedMetalProductsIcon from "../../components/Icons/FabricatedMetalProductsIcon";
import IndustrialCommercialMachineryComputerEquipmentIcon from "../../components/Icons/IndustrialCommercialMachineryComputerEquipmentIcon";
import TextileMillProductIcon from "../../components/Icons/TextileMillProductIcon";
import ApparelFinishedProductsIcon from "../../components/Icons/ApparelFinishedProductsIcon";
import PrimaryMetalsIndustryIcon from "../../components/Icons/PrimaryMetalsIndustryIcon";
import RubberMiscellaneousPlasticProductsIcon from "../../components/Icons/RubberMiscellaneousPlasticProductsIcon";
import ElectronicEquipmentComponentsIcon from "../../components/Icons/ElectronicEquipmentComponentsIcon";

const LeftSideNav = () => {
  const navigation = useNavigate();
  const { sectorId } = useParams();
  const { sectorPopularData } = useSectorsContext();
  const [currentIndustryId, setCurrentIndustryId] = useState(sectorId);
  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  const handleSectorClickRedirect = (sectorId) => {
    setCurrentIndustryId(sectorId);
    navigation(`/sector/${sectorId}/details`);
  };

  // keep the selected/highlighted icon in sync with the URL
  useEffect(() => {
    setCurrentIndustryId(sectorId);
  }, [sectorId]);

  // Hidden sector IDs
  const hiddenSectorIds = [
    "67c59f894605e819d8fb86ce", // TransportationEquipmentIcon
    "67c59f894605e819d8fb86c4", // FabricatedMetalProductsIcon
    "67c59f894605e819d8fb86bc", // IndustrialCommercialMachineryComputerEquipmentIcon
    "67c59f894605e819d8fb86cd", // RubberMiscellaneousPlasticProductsIcon
    "67c59f894605e819d8fb86c5", // ElectronicEquipmentComponentsIcon
  ];

  const getSectorIcon = (sectorId) => {
    switch (sectorId) {
      case "67c59f894605e819d8fb86ca":
        return FoodKindredProductsIcon;
      case "67c59f894605e819d8fb86c4":
        return FabricatedMetalProductsIcon;
      case "67c59f894605e819d8fb86af":
        return TextileMillProductIcon;
      case "67c59f894605e819d8fb86bc":
        return IndustrialCommercialMachineryComputerEquipmentIcon;
      case "67c59f894605e819d8fb86c0":
        return ApparelFinishedProductsIcon;
      case "67c59f894605e819d8fb86c3":
        return PrimaryMetalsIndustryIcon;
      case "67c59f894605e819d8fb86cd":
        return RubberMiscellaneousPlasticProductsIcon;
      case "67c59f894605e819d8fb86c5":
        return ElectronicEquipmentComponentsIcon;
      default:
        return null;
    }
  };

  return (
    <VStack className="left-side-nav">
      <VStack align="start" fontSize="14px">
        {sectorPopularData &&
          sectorPopularData.map((sector) => {
            if (hiddenSectorIds.includes(sector._id)) return null;

            const IconComponent = getSectorIcon(sector._id);
            if (!IconComponent) return null;

            return (
              <Box
                className="industry-block-icon"
                bgColor={sector._id === currentIndustryId ? "#B1B1B1" : "#FFFFFF"}
                key={`sector-${sector._id}`}
              >
                <Menu>
                  <Tooltip label={sector.sectorName} fontSize="11px">
                    <MenuButton
                      // onClick={() => {
                      //   if (!isAuthenticatedUser) {
                      //     handleSectorClickRedirect(sector._id);
                      //   }
                      // }}
                      onClick={() => handleSectorClickRedirect(sector._id)}
                    >
                      <IconComponent
                        color={sector._id === currentIndustryId ? "#FFFFFF" : "#5D5D5D"}
                      />
                    </MenuButton>
                  </Tooltip>
                </Menu>
              </Box>
            );
          })}
      </VStack>
    </VStack>
  );
};

export default LeftSideNav;
